module.exports = __webpack_public_path__ + "static/media/slide2.5a730072.png";